import { GuardedComponent } from '../components/guarded-component';
import { BulkSchedulingPage } from '../features/scheduling/bulk-scheduling.page';
import { UserPermissionName } from '../models/user-permission-name';

export const SchedulingRoute = {
  path: '/scheduling',
  element: (
    <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_BULKSCHEDULING]} showPermissionError>
      <BulkSchedulingPage />
    </GuardedComponent>
  ),
};
